import { Link } from 'react-router-dom';
import { navItems } from './navItems';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center text-base font-black">
                51
              </span>
              <span className="text-lg font-black tracking-tight">51每日大赛</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-sm">
              {siteInfo.intro}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 tracking-wide">导航</h4>
            <ul className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 tracking-wide">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>{siteInfo.contactEmail}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-briefcase-line text-accent-400"></i>
                <span>商务合作：{siteInfo.cooperationEmail}</span>
              </li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              {siteInfo.social.map((s) => (
                <span
                  key={s.name}
                  title={s.name}
                  className="w-9 h-9 rounded-md bg-primary-900 hover:bg-accent-500 hover:text-primary-950 flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-10 text-xs leading-relaxed text-background-400 border-t border-primary-800 pt-6">
          {siteInfo.disclaimer}
        </p>
        <p className="mt-3 text-xs text-background-400">
          © {new Date().getFullYear()} 51每日大赛 · 保留所有权利
        </p>
      </div>
    </footer>
  );
}